module.exports = __webpack_public_path__ + "static/media/crowd-background.88d5ae94.jpg";